module.exports = __webpack_public_path__ + "static/media/appstore-download-badge.f3f8e1e1.png";